import {
  EDITORIAL_NEXT_STEP_OPTIONS,
  editorialNextStep,
} from '@/components/reach/editorial/editorial-next-step';
import type { EditorialWorkflowStatusId } from '@/components/reach/editorial/editorial-status-ids';
import { SegmentedRing } from '@/components/ui/segmented-ring';
import type { ArticlePublicationSummary } from '@/hooks/reach/useArticleHandoff';
import type { EditorialArticleScore } from '@/hooks/reach/useEditorialArticleTrail';
import {
  type ArticleApprovalState,
  deriveArticleProgress,
  summariseArticleProgress,
} from '@/lib/content-doctrine/article-progress';

export function EditorialProgressRing({
  hasArticle,
  statusId,
  score,
  approval,
  publication,
  describedById,
  size = 'sm',
  focusable,
  forceOpen,
  className,
}: {
  hasArticle: boolean;
  statusId: EditorialWorkflowStatusId;
  score?: EditorialArticleScore | null;
  approval?: ArticleApprovalState | null;
  publication?: ArticlePublicationSummary | null;
  describedById?: string;
  size?: 'sm' | 'md';
  focusable?: boolean;
  forceOpen?: boolean;
  className?: string;
}): JSX.Element {
  const progress = deriveArticleProgress({
    hasArticle,
    release: score ?? null,
    contentHash: score?.contentHash ?? null,
    approval: approval ?? null,
    publication: publication ?? null,
    factCheck: score?.factCheck ?? null,
  });
  const step = editorialNextStep({ statusId, hasArticle, score, approval });
  const nextStep =
    step === 'done'
      ? null
      : (EDITORIAL_NEXT_STEP_OPTIONS.find((o) => o.value === step)?.label ?? null);
  return (
    <SegmentedRing
      segments={progress.stages}
      nextStep={nextStep}
      describedById={describedById}
      ariaLabel={summariseArticleProgress(progress, nextStep)}
      size={size}
      focusable={focusable}
      forceOpen={forceOpen}
      className={className}
    />
  );
}
